import { useEffect } from "react";
import { useParams } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { AuthContainer } from "@templates/authManagement/authContainer";
import { useAuthStore } from "@templates/authManagement/authStore";

import type { IAuthStepEnum } from "@templates/authManagement/authStore";

export function AuthManagement() {
  const type = useParams<{ type: string }>().type as IAuthStepEnum;
  const setStep = useAuthStore(useShallow((state) => state.setStep));

  useEffect(() => {
    setStep(type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return <AuthContainer />;
}
